import React from 'react';
import { Wrench, Facebook, Instagram, MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-navy text-white pt-20 pb-8 border-t-4 border-brand-red" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-53">
          {/* Brand Col */}
          <div data-id="element-54">
            <div className="flex items-center gap-3 mb-6" data-id="element-55">
              <div className="bg-white p-2 rounded-md flex items-center justify-center" data-id="element-56">
                <Wrench className="w-6 h-6 text-brand-red" data-id="element-57" />
              </div>
              <div className="flex flex-col" data-id="element-58">
                <span className="font-display font-bold text-2xl leading-none text-white uppercase tracking-wide" data-id="element-59">
                  Done Right
                </span>
                <span className="text-[10px] font-bold text-brand-red uppercase tracking-widest" data-id="element-60">
                  Plumbing Inc.
                </span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-61">
              Providing top-tier residential and commercial plumbing services
              with a commitment to quality workmanship and honest pricing since
              1990.
            </p>
            <div className="flex gap-4" data-id="element-62">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-63">
                <Facebook className="w-5 h-5" data-id="element-64" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-65">
                <Instagram className="w-5 h-5" data-id="element-66" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors font-bold font-display" data-id="element-67">
                G
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-68">
            <h4 className="font-display font-bold text-xl uppercase mb-6 tracking-wide" data-id="element-69">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-70">
              <li data-id="element-71">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-72">
                  Home
                </a>
              </li>
              <li data-id="element-73">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-74">
                  About Us
                </a>
              </li>
              <li data-id="element-75">
                <a href="#resources" className="text-gray-400 hover:text-white transition-colors" data-id="element-76">
                  Helpful Resources
                </a>
              </li>
              <li data-id="element-77">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-78">
                  Contact Us
                </a>
              </li>
              <li data-id="element-79">
                <a href="#careers" className="text-gray-400 hover:text-white transition-colors" data-id="element-80">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-81">
            <h4 className="font-display font-bold text-xl uppercase mb-6 tracking-wide" data-id="element-82">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-83">
              <li data-id="element-84">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-85">
                  Residential Plumbing
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-87">
                  Commercial Plumbing
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-89">
                  Emergency Repairs
                </a>
              </li>
              <li data-id="element-90">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-91">
                  Water Heaters
                </a>
              </li>
              <li data-id="element-92">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-93">
                  Drain & Sewer
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-94">
            <h4 className="font-display font-bold text-xl uppercase mb-6 tracking-wide" data-id="element-95">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-96">
              <li className="flex items-start gap-3" data-id="element-97">
                <Phone className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-98" />
                <a href="tel:7026425352" className="text-gray-400 hover:text-white transition-colors" data-id="element-99">
                  (702) 642-5352
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-100">
                <Mail className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-101" />
                <span className="text-gray-400" data-id="element-102">
                  service@donerightplumbing.com
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-103">
                <MapPin className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-104" />
                <span className="text-gray-400" data-id="element-105">
                  900 W Warm Springs Road, Suite 102
                  <br data-id="element-106" />
                  Henderson, Nevada 89011
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-107">
                <Clock className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-108" />
                <span className="text-gray-400" data-id="element-109">
                  24/7 Emergency Service Available
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-110">
          <p data-id="element-111">
            &copy; {new Date().getFullYear()} Done Right Plumbing Inc. All
            rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-112">
            <span data-id="element-113">License #319535</span>
            <a href="#covid-safety" className="hover:text-white transition-colors" data-id="element-114">
              COVID-19 Safety
            </a>
            <a href="#privacy" className="hover:text-white transition-colors" data-id="element-115">
              Privacy Policy
            </a>
          </div>
        </div>
        <div className="mt-6 text-center text-xs text-gray-500" data-id="element-116">
          Powered by{' '}
          <a href="https://mindstream.ing" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-117">
            MindStream.ing
          </a>
        </div>
      </div>
    </footer>;
}